import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";

export const TimeSlotSelect = ({ date, mode, stationId, emirate, value, onChange, testId, onNoneAvailable, onClosed }) => {
  const { t } = useTranslation();
  const [slots, setSlots] = useState([]);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const onNoneRef = useRef(onNoneAvailable);
  onNoneRef.current = onNoneAvailable;
  const onClosedRef = useRef(onClosed);
  onClosedRef.current = onClosed;

  useEffect(() => {
    if (!date || (mode === "branch" && !stationId) || (mode === "delivery" && !emirate)) return;
    let ignore = false;
    const params = { date, mode };
    if (mode === "branch") params.station_id = stationId;
    else params.emirate = emirate;
    api.get("/time-slots", { params })
      .then((r) => {
        if (ignore) return;
        setSlots(r.data.slots);
        const avail = r.data.slots.filter((s) => s.available);
        if (avail.length === 0) {
          const closed = mode === "branch" && r.data.slots.some((s) => /closed on this day/i.test(s.reason || ""));
          if (closed) onClosedRef.current?.(r.data.branch || "");
          else onNoneRef.current?.();
          return;
        }
        const current = r.data.slots.find((s) => s.value === Number(value));
        if (!current || !current.available) onChangeRef.current(avail[0].value);
      })
      .catch(() => { if (!ignore) setSlots([]); });
    return () => { ignore = true; };
  }, [date, mode, stationId, emirate, value]);

  // Delivery: only show times we actually deliver (drop out-of-window / unavailable slots).
  // Branch: show all times, greying out the ones that aren't bookable.
  const display = mode === "delivery" ? slots.filter((s) => s.available) : slots;
  const noneAvailable = slots.length > 0 && slots.every((s) => !s.available);

  return (
    <div>
      <select className="field-input" value={value ?? ""} onChange={(e) => onChange(Number(e.target.value))} data-testid={testId}>
        {display.length === 0 && <option value="">{noneAvailable ? t("No times available") : t("Loading times…")}</option>}
        {display.map((s) => (
          <option key={s.value} value={s.value} disabled={!s.available} className={s.available ? "" : "text-[#9aa79f]"}>
            {s.time}{s.available ? "" : ` — ${s.reason}`}
          </option>
        ))}
      </select>
      {noneAvailable && (
        <p className="text-[11px] text-amber-700 mt-1" data-testid="no-times-notice">
          {mode === "delivery"
            ? t("No delivery times left on this date — try the next day.")
            : t("No times available on this date — try the next day or a nearby branch.")}
        </p>
      )}
    </div>
  );
};
